export default "__VITE_ASSET__c_AVkzZN__"